// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credit-lines-viewport {
  display: flow-root;
  position: relative;
}

.credit-lines-viewport.is-scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-y: contain;
}

/* Reserve the same scrollbar space in column headings and their rows. */
.credit-lines-viewport.is-scrollable,
.credit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .credit-lines-head,
.debit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .debit-line-head {
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--border-strong) transparent;
}

.credit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .credit-lines-head,
.debit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .debit-line-head {
  overflow-y: hidden;
}

.credit-lines-viewport:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/CreditNote/creditLinesViewport.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,wEAAwE;AACxE;;;EAGE,wBAAwB;EACxB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB","sourcesContent":[".credit-lines-viewport {\n  display: flow-root;\n  position: relative;\n}\n\n.credit-lines-viewport.is-scrollable {\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior-y: contain;\n}\n\n/* Reserve the same scrollbar space in column headings and their rows. */\n.credit-lines-viewport.is-scrollable,\n.credit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .credit-lines-head,\n.debit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .debit-line-head {\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-strong) transparent;\n}\n\n.credit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .credit-lines-head,\n.debit-lines-table:has(> .credit-lines-viewport.is-scrollable) > .debit-line-head {\n  overflow-y: hidden;\n}\n\n.credit-lines-viewport:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
